import { Injectable, Injector } from '@angular/core';
import { TenantNames } from '@mynexus/mynexus-ui-lib';
import { ShellService } from '@mynexus/mfe-core';
import { HttpClient } from '@angular/common/http';
import { IAuthorizationDTO } from '@app/core/model/authorization.model';
import { DocumentFileType, ICoreMemberDTO } from '@app/core/model';
import { IDocumentResponseDTO } from '@products/dmepos/models';

interface DocumentTypeConfig {
  mailOnly?: boolean;
  exclude: string[];
  include?: string[];
}

export type SendFaxDocumentTypeConfig = Readonly<Record<string, DocumentTypeConfig>>;

@Injectable()
export abstract class SendFaxBaseService {
  protected readonly apiUrl: string;
  protected readonly shellService: ShellService;
  protected readonly http: HttpClient;

  constructor(
    protected injector: Injector,
  ) {
    this.shellService = this.injector.get(ShellService);
    this.http = this.injector.get(HttpClient);
    this.apiUrl = this.shellService.getBaseUrlFor();
  }

  abstract documentTypeConfig: SendFaxDocumentTypeConfig;

  abstract sendLetter(payload: any, authorizationId?: string, tenantId?: string);

  abstract sendFax(payload: any, authorizationId?: string, tenantId?: string);

  abstract getDocumentTypes(authorization?: IAuthorizationDTO, tenantName?: TenantNames, memberDto?: ICoreMemberDTO | null): DocumentFileType[] | any;

  abstract filterDocuments(documents: IDocumentResponseDTO[]): IDocumentResponseDTO[];

  mapAuthorizationDetails(authorizationDetails: any): any {}
}
